/**
 * Where an uploaded grade sheet lives.
 *
 * The folder is the subject's code, and a code is free text the registrar types
 * by hand. "AFA/FCS/IA6-10012026" is one of them, from the day EPP/TLE split
 * into its two components. Interpolated raw, those slashes stop being part of
 * the name and become path separators: the request matches no route at all and
 * the server answers 404, "Shared class Container has no method handling GET".
 * The sheet looks lost. It is sitting in storage, untouched - the link was the
 * only broken thing.
 *
 * So every segment is encoded, the file name included: a space or an ampersand
 * in a teacher's file name breaks a URL exactly as readily as a slash.
 *
 * "2019-2020" is not the school year. It is the one folder every sheet has ever
 * been filed under, and it stays, because that is where the files are.
 */
export function gradeSheetLink(folder, fileName) {
  if (!folder || !fileName) return null;

  return (
    `${process.env.REACT_APP_URL}/containers/` +
    `${process.env.REACT_APP_CONTAINER}/download/` +
    `2019-2020%2F${encodeURIComponent(folder)}%2F${encodeURIComponent(fileName)}`
  );
}
